(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-returns"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-returns-tabs]').forEach((root) => {
    const tabs = root.querySelectorAll('[data-returns-tab]');
    const panels = root.querySelectorAll('[data-returns-panel]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.getAttribute('data-returns-tab');

        tabs.forEach((other) => {
          const isActive = other === tab;
          other.classList.toggle('is-active', isActive);
          other.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const matches = panel.getAttribute('data-returns-panel') === target;
          panel.toggleAttribute('hidden', !matches);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
